import React, { useEffect, useMemo, useState } from "react";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { RESULT_STATUS } from "../../../constants";
import Table from "../../CommonComponents/Table";
import useAuth from "../../../Hooks/useAuth";
import Loading from "../../Notification-Loading/Loading/Loading";

const PathList = ({ searchValue = "", archieve = false }) => {
  const axios = useAxiosPrivate();
  const { navigate, setShowNotify } = useAuth();

  const [paths, setPaths] = useState([]);
  const [filteredPaths, setFilteredPaths] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const columns = useMemo(()=>
    [
      {
        key: "name",
        title: "Name",
        className: "admin-path-list-item-name",
      },
      {
        key: "description",
        title: "Description",
        className: "admin-path-list-item-description",
      },
      {
        key: "createdby",
        title: "Createdby",
        className: "admin-path-list-item-createdby",
      }
    ],
    [],
  );

  useEffect(() => {
    const fetchPaths = async () => {
      try {
        setIsLoading(true);
        const { data } = await axios.get(
          `node/admin/learningpath?archived=${archieve}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        console.log("data", data);
        if (data?.resultCode === RESULT_STATUS.SUCCESS) {
          let response = data?.data || [];
          response = response.map((item) => {
            if (!item.createdby || item.createdby === "null")
              item.createdby = "-";
            return item;
          });
          setPaths(response);
          setFilteredPaths(response);
        } else {
          setShowNotify({
            title: "Warning !",
            msg:
              data?.msg ??
              `Unable to get the path list. Please try again later`,
            show: true,
          });
        }
      } catch (error) {
        console.error("error in fetch paths", error);
        let isUnAuth = error.message.includes("403");
        setShowNotify({
          isUnAuth,
          title: isUnAuth ? "Warning !" : "Error !",
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : error.message ??
              `Unable to get the path list. Please try again later`,
          show: true,
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchPaths();
  }, [axios, setIsLoading, setShowNotify, archieve]);

  useEffect(() => {
    setFilteredPaths((prev) =>
      paths.filter((item) =>
        item.name.toLowerCase().includes(searchValue.toLowerCase()),
      ),
    );
  }, [searchValue, paths]);

  return (
    <div className="admin-path-list-container">
      <Table
        columns={columns}
        fixedHeader
        bordered
        data={filteredPaths}
        className="admin-path-list-table"
        onRowClick={(row) => navigate(`/learningpath/${row.id}`)}
      />
      {isLoading && <Loading overlay/>}
    </div>
  );
};

export default PathList;
